import React from 'react';
import {UpIcon, DownIcon, LeftIcon, RightIcon} from './Icons';
import {CONSTANTS} from '../../ZoomImage.utils';
import {ZoomContext} from '../../index';
/**
 * ScrollMenu
 *  - The Up/Down/Left/Right Menu buttons that let you navigate the image
 */
export function ScrollMenu() {
  const {updateScroll} = React.useContext(ZoomContext);

  const onLeftClick = () => updateScroll(CONSTANTS.DIRECTION.LEFT);

  const onRightClick = () => updateScroll(CONSTANTS.DIRECTION.RIGHT);

  const onTopClick = () => updateScroll(CONSTANTS.DIRECTION.UP);

  const onBottomClick = () => updateScroll(CONSTANTS.DIRECTION.DOWN);

  return (
    <div className='scrollMenuBlock'>
      <div
        role='button'
        tabIndex={0}
        className='scrollMenuBlock_left'
        onClick={onLeftClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onLeftClick();
          }
        }}
      >
        <LeftIcon className='icon' />
      </div>
      <div className='scrollMenuBlock_middle'>
        <div
          role='button'
          tabIndex={0}
          onClick={onTopClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onTopClick();
            }
          }}
        >
          <UpIcon className='icon' />
        </div>
        <div
          role='button'
          tabIndex={0}
          onClick={onBottomClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onBottomClick();
            }
          }}
        >
          <DownIcon className='icon' />
        </div>
      </div>
      <div
        role='button'
        tabIndex={0}
        className='scrollMenuBlock_right'
        onClick={onRightClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onRightClick();
          }
        }}
      >
        <RightIcon className='icon' />
      </div>
    </div>
  );
}

ScrollMenu.propTypes = {};
